import OutLineMobileThree from '@assets/icons/outline-mobile-three.svg'
import { Icon } from './Icon'

export const OutLineMobileThreeIcon = Icon(OutLineMobileThree)
